import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'input[evenNumbersOnlyMax]'
})
// tslint:disable-next-line:directive-class-suffix
export class EvenNumbersMaxDirective  {

  private el: NgControl;

  constructor(private ngControl: NgControl) {
    this.el = ngControl;
  }

  // tslint:disable-next-line:no-input-rename
  @Input('evenNumbersOnlyMax') maxNumber: number;

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Use NgControl patchValue to prevent the issue on validation
    value = value.replace(/[^0-9]/g, '');
    if (value.length > this.maxNumber.toString().length){
      value = value.slice(0, -1);
    }

    // tslint:disable-next-line:radix
    if (parseInt(value) > this.maxNumber){
      value = value.slice(0, this.maxNumber.toString().length - 1);
    }
    this.el.control.patchValue(value);
  }

}
